// @ts-strict-ignore
import { Pipe, PipeTransform } from '@angular/core';
import { LMListUtilService } from '@list/services/lm-list-util.service';
import { LMModelField } from '@form/model';

@Pipe({
  name: 'toFieldOperator'
})
export class LMFieldOperatorPipe implements PipeTransform {

  constructor(private lmListUtilService: LMListUtilService) {}

  /**
   * transforms landmark field filter format to soho field filter format
   * @param   modelField     LMModelField
   * @param   defaultValue LMFilterFieldOperator
   * @return              SohoFieldFilterOperator
   */
  transform(triggerValue: boolean, modelField: LMModelField, defaultValue?: LMFilterFieldOperator): SohoFieldFilterOperator {
    let value = modelField?.filterType ? modelField.filterType : null;

    if (!!modelField?.filterCriteria) {
      value = modelField.filterCriteria.operator;
    }
    // set with default value or 'equals'
    if (!value) {
      value = defaultValue ? defaultValue : 'equals';
    }
    return this.lmListUtilService.getSohoOperator(value);
  }
}
